import { atom } from 'recoil';
import { Popup } from '../interfaces/Popup/Popup';

export const popupsAtom = atom<Popup[] | undefined>({
  key: 'popupsState',
  default: undefined,
});
